import NoRecord from '../../../../../../../../components/common/NoContent/NoRecord'
import NoRecordImage from '../../../../../../../../assets/images/setting.svg'
import React from 'react'
import Spinner from '../../../../../../../../components/common/Spinner/Spinner'
import { ToastMessageConstants } from '../../../../../../../../constants/ToastMessageConstants'
import ToastNotification from '../../../../../../../../components/common/DDS/Toast/Toast'
import UserHistory from './UserHistory'
import { getOrganizationUsageHistory } from '../../../../../../../../api/organization/Organization.service'
import moment from 'moment'
import { observer } from 'mobx-react-lite'

const featureLabelMap: Record<string, string> = {
  user: 'Users',
  project: 'Projects',
  escalation: 'Escalations',
  apiMonitoring: 'API Monitoring',
  jobMonitoring: 'Job Monitoring',
  incident: 'Incidents',
  applicationHealthCheck: 'Uptime Checks',
  exception: 'Exceptions'
}

interface UsageData {
  type: string
  allowed: string
  used: number
}

interface UsageHistory {
  timeframe: string
  data: UsageData[]
}

interface ApiUsageData {
  feature: string
  active: number
  archived: number
  maxLimit: number
}

interface ApiResponseItem {
  monthYear: string
  usageData: ApiUsageData[]
}

const transformUsageData = (apiResponse: any): UsageHistory[] => {
  try {
    const result = apiResponse.data.map((item: ApiResponseItem) => {
      const usageData: UsageData[] = item.usageData.map((ud) => ({
        type: featureLabelMap[ud.feature] || ud.feature,
        allowed:
          ud.maxLimit === -1 ? 'Unlimited' : ud.maxLimit.toLocaleString(),
        used: ud.active ?? 0
      }))

      const start = moment(item.monthYear, 'YYYY-MM')
      const end = start.clone().add(1, 'month')
      const timeframe = `${start.format('MMM YYYY')} - ${end.format('MMM YYYY')}`

      return {
        timeframe,
        data: usageData
      }
    })

    return result
  } catch (error) {
    console.error('Error in transformUsageData:', error)
    return []
  }
}

const BillingPlans = () => {
  const [loading, setLoading] = React.useState<boolean>(false)
  const [usageHistory, setUsageHistory] = React.useState<UsageHistory[]>([])

  React.useEffect(() => {
    setLoading(true)
    getOrganizationUsageHistory()
      .then((response: any) => {
        const mapped = transformUsageData(response)

        setUsageHistory(mapped)
      })
      .catch((error) => {
        console.error('Error fetching usage history:', error)
        ToastNotification({
          type: 'error',
          message: ToastMessageConstants.STRIPE
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className='flex pt-[24px] gap-[12px] flex-col w-full h-full'>
          {Array.isArray(usageHistory) && usageHistory.length > 0 ? (
            usageHistory.map((item, idx) => (
              <UserHistory
                key={idx}
                timeframe={item.timeframe}
                data={item.data}
              />
            ))
          ) : (
            <NoRecord
              imageSrc={NoRecordImage}
              style={{ height: '65vh' }}
              text={<div>No usage history found</div>}
            />
          )}
        </div>
      )}
    </>
  )
}

export default observer(BillingPlans)
